import { render, staticRenderFns } from "./ed-create-quick-subject.component.vue?vue&type=template&id=c45d92ce&scoped=true&"
import script from "./ed-create-quick-subject.component.ts?vue&type=script&lang=ts&"
export * from "./ed-create-quick-subject.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-create-quick-subject.component.scss?vue&type=style&index=0&id=c45d92ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45d92ce",
  null
  
)

export default component.exports